import { useEffect } from 'react';
import { sendScreenEvent } from '@useblu/blu-lytics';
import { useNavigate, useParams } from 'react-router-dom';

import { getPaymentLinkById } from '@/services/api';
import { hasFailedAttempt, isExpired, isPaid } from '@/utils/paymentLink';

const useRedirect = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const handleGetLinkData = async () => {
    await getPaymentLinkById(id).then(response => {
      const data = response.data.data;

      if (isExpired(data)) {
        navigate('/unavailable');
        return;
      }

      const paymentFailed = data.status === 'created' && hasFailedAttempt(data);

      if (paymentFailed || isPaid(data)) {
        navigate(`/success/${id}`);
      }
    });
  };

  useEffect(() => {
    sendScreenEvent('link_blu_checkout_owner_payment_view');
  }, []);

  useEffect(() => {
    handleGetLinkData();

    const interval = setInterval(() => {
      handleGetLinkData();
    }, 5000);

    return () => clearInterval(interval);
  }, []);
};

export default useRedirect;
